class NaviAutoScroll {
  constructor(element) {
    this.nav = element;
    this.activeHeader = this.nav.querySelector('._current');

    if (this.activeHeader !== null) {
      $(window).resize(() => {
        this.onResize();
      });
      this.onResize();
    }
  }

  static offsetLeft(element) {
    const rect = element.getBoundingClientRect();
    const scrollLeft =
      window.pageXOffset || document.documentElement.scrollLeft;

    return rect.left + scrollLeft;
  }

  onResize() {
    if (this.nav.scrollWidth > this.nav.clientWidth) {
      const scrollOffset =
        this.activeHeader.clientWidth -
        (this.nav.clientWidth - NaviAutoScroll.offsetLeft(this.activeHeader));
      const marginOffset = 0;
      const scrollLeft = this.nav.scrollLeft + scrollOffset + marginOffset;
      const maxOffset = this.nav.scrollWidth - this.nav.clientWidth;
      let targetScrollLeft = 0;

      if (scrollLeft > 0) {
        if (scrollLeft > maxOffset) {
          targetScrollLeft = maxOffset;
        } else {
          targetScrollLeft = scrollLeft;
        }
      }
      this.nav.scrollLeft = targetScrollLeft;
    }
  }
}

export default function localNav() {
  const localNavElements = document.querySelectorAll('.p-localNav');

  localNavElements.forEach(element => {
    // eslint-disable-next-line no-new
    new NaviAutoScroll(element);
  });
}
